


















































































































































































































import MatronItem from '../common/matron_item.vue'
import ConsultantItem from '../common/consultant_item.vue'
import ProductItem from '../common/product_item.vue'
import BusinessItem from '../common/business_item.vue'
import SearchCategory from '../common/search_category.vue'
import Screen from '../common/search_screen.vue'
import NewScreen from '../common/search_new_screen.vue'
import ScenicItem from '../common/scenic_item.vue'
import HotelItem from '../common/hotel_item.vue'
import StudyItem from '../common/study_item.vue'
import { getSearchResult, RequestType } from '../../search-service'
import { Component, Vue, Inject, Provide } from 'vue-property-decorator'
import { getPosition, getSelectedCity, getSelectterm } from '@utils/index'
import { namespace } from 'vuex-class'
import { List } from 'vant'
import { includes, isString, slice } from 'lodash'
import { creatCollectForm } from '../../../home/components/search/utils'
import { CATEGORY_ID_MAP } from '../../enum'
import { City } from '@/app/core/constant/city'
import { hotelSort } from '@/app/core/constant/search'
import { studySort } from '@/app/core/constant/search'

const searchResModule = namespace('searchRes') //vuex

export enum TabType {
  BUSINESS = '商家',
  PRODUCT = '商品',
  MATRON = '月嫂',
  CONSULTANT = '育儿顾问',
  SCENIC = '景点',
  STUDY = '研学',
  HOTEL = '酒店'
}

export enum SearchRefresh {
  RefreshAll = 'refreshall',
  RefreshBusiness = 'refreshbusiness',
  RefreshProduct = 'refreshproduct',
  RefreshMatron = 'refreshmatron',
  RefreshConsultant = 'refreshconsultant',
  RefreshThirdPartScenic = 'refreshthirdpartscenic',
  RefreshStudy = 'refreshstudy',
  RefreshHotel = 'refreshhotel'
}

@Component({
  components: {
    [List.name]: List,
    ProductItem,
    BusinessItem,
    SearchCategory,
    MatronItem,
    ConsultantItem,
    Screen,
    NewScreen,
    ScenicItem,
    HotelItem,
    StudyItem
  },
  filters: {
    keywordFilter(keyword: any) {
      if (isString(keyword)) {
        if (keyword.length > 6) {
          return keyword.substring(0, 6) + '...'
        }
      }
      return keyword
    }
  }
})
export default class SearchAll extends Vue {
  @searchResModule.State categoryList!: any
  @searchResModule.State districtList!: any
  @searchResModule.State levelList!: any
  @searchResModule.State bRightList!: any
  @searchResModule.State storeList!: any

  @searchResModule.State researchTypes!: any[]
  @searchResModule.State researchThemes!: any[]
  @searchResModule.State researchAgeTypes!: any[]
  @searchResModule.State researchDirections!: any[]

  @searchResModule.Mutation setBusinessNum!: (arg: number | null) => void
  @searchResModule.Mutation setProductNum!: (arg: number | null) => void
  @searchResModule.Mutation setYueSaoNum!: (arg: number | null) => void
  @searchResModule.Mutation setYuerNum!: (arg: number | null) => void
  @searchResModule.Mutation setThirdPartScenicNum!: (arg: number | null) => void
  @searchResModule.Mutation setResearchStudyNum!: (arg: number | null) => void
  @searchResModule.Mutation setHotelNum!: (arg: number | null) => void

  @searchResModule.State businessNum!: number | null
  @searchResModule.State productNum!: number | null
  @searchResModule.State yueSaoNum!: number | null
  @searchResModule.State yuerNum!: number | null
  @searchResModule.State thirdPartScenicNum!: number | null
  @searchResModule.State researchStudyNum!: number | null
  @searchResModule.State hotelNum!: number | null

  @searchResModule.Mutation setCategoryList!: (arg: any) => void
  @searchResModule.Mutation setLevelList!: (arg: any) => void
  @searchResModule.Mutation setBrightList!: (arg: any) => void
  @searchResModule.Mutation setStoreList!: (arg: any) => void
  @searchResModule.Mutation setStudyScreen!: (arg: any) => void

  @searchResModule.Mutation setBusinessCategorySelect!: (arg: any) => void //设置商家分类
  @searchResModule.Mutation setProductCategorySelect!: (arg: any) => void //设置商品分类

  @searchResModule.Mutation setBusinessDistrictSelect!: (arg: any) => void //设置商家全城
  @searchResModule.Mutation setProductDistrictSelect!: (arg: any) => void //设置商品全城

  @searchResModule.Mutation setYueSaoLevelSelect!: (arg: any) => void //设置月嫂等级
  @searchResModule.Mutation setYueSaoBrightSelect!: (arg: any) => void //设置月嫂等级
  @searchResModule.Mutation setYueSaoDistrictSelect!: (arg: any) => void //设置月嫂全城

  @searchResModule.Mutation setYuerStoreSelect!: (arg: any) => void //设置育儿顾问门店
  @searchResModule.Mutation setYuerDistanceSort!: (arg: any) => void //设置育儿顾问排序
  @searchResModule.Mutation setYuerGoodCommentsSort!: (arg: any) => void //设置育儿顾问排序

  @searchResModule.Mutation setBusinessDistanceSort!: (arg: any) => void //设置商家距离排序
  @searchResModule.Mutation setBusinessGoodCommentSort!: (arg: any) => void //设置商家好评排序
  @searchResModule.Mutation setProductDistanceSort!: (arg: any) => void //设置商品距离排序
  @searchResModule.Mutation setProductSalesSort!: (arg: any) => void //设置商品销量排序
  @searchResModule.Mutation setProductDefaultSort!: (arg: any) => void //设置商品距离排序

  @searchResModule.Mutation setLocation!: (arg: any) => void //设置定位
  @searchResModule.Mutation setSelectCity!: (arg: any) => void //设置定位

  @searchResModule.Mutation selectThirdPartScenicScreen!: (arg: string) => void
  @searchResModule.State selectCity!: City
  @searchResModule.State thirdPartScenicScreen!: string[]

  @searchResModule.Mutation selectHotelSortInfo!: (arg: string) => void

  @searchResModule.Mutation selectStudySortInfo!: (arg: any) => void
  @searchResModule.Mutation selectAgeTypeInfo!: (arg: any) => void
  @searchResModule.Mutation selectTypeInfo!: (arg: any) => void
  @searchResModule.Mutation selectThemeInfo!: (arg: any) => void
  @searchResModule.Mutation selectDirection!: (arg: any) => void
  @searchResModule.Mutation selectStudySelf!: (arg: boolean) => void

  @Inject('pageTrackParams')
  pageTrackParams!: any
  @Inject('clickid_200019')
  clickid_200019!: string
  @Inject('clickid_200018')
  clickid_200018!: string
  @Inject('clickid_200017')
  clickid_200017!: string
  @Inject('clickid_200016')
  clickid_200016!: string
  @Inject('clickid_200015')
  clickid_200015!: string
  @Inject('clickid_200014')
  clickid_200014!: string
  @Inject('clickid_200013')
  clickid_200013!: string
  @Inject('clickid_200012')
  clickid_200012!: string
  @Inject('clickid_200011')
  clickid_200011!: string
  @Inject('clickid_200010')
  clickid_200010!: string
  @Inject('clickid_200009')
  clickid_200009!: string
  @Inject('clickid_200008')
  clickid_200008!: string

  @Provide()
  clickid_200007 = '200007'
  @Provide()
  clickid_200005 = '200005'
  @Provide()
  clickid_200004 = '200006'
  @Provide()
  clickid_200003 = '200004'
  @Provide()
  clickid_200002 = '200003'
  @Provide()
  clickid_200001 = '200002'
  @Provide()
  clickid_200031 = '200031'
  @Provide()
  clickid_home_product = '' // 黄燕添加

  yueSaoTop = false
  loading = true
  finished = false
  thirdPartScenicList: any[] = []
  businessList: any[] = []
  productList: any[] = []
  matronList: any[] = [] //月嫂
  consultantList: any[] = [] //育儿顾问
  researchStudyList: any[] = []
  hotelList: any[] = []
  location: any = null
  keyWord = ''
  errormsg = ''
  studyClassifySticky = 0 //研究学习分类吸顶需要移动的距离
  businessClassifySticky = 0 //商家分类吸顶需要移动的距离
  productClassifySticky = 0 //商品分类吸顶需要移动的距离
  matronClassifySticky = 0 //月嫂筛选吸顶需要移动的距离
  consultantClassifySticky = 0 //育儿顾问筛选吸顶需要移动的距离
  isAutoTabChangeForQuery = true //链接上带tabIndex参数时 自动切换tab 执行一次

  hotelSorts = hotelSort
  studySort = studySort
  maxShow = 8 //最多显示8条
  selectterm = ''
  async created() {
    this.location = await getPosition(false)
    this.setLocation(this.location)
    this.setSelectCity(await getSelectedCity())
    this.selectterm = await getSelectterm()
    this.refresh()

    // if (cookies.get('uid') && cookies.get('city') && this.isSendForm.length) {
    if (this.isSendForm.length) {
      // 发送收集表单请求
      const categoryName = this.isSendForm[0]
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const categoryId = CATEGORY_ID_MAP[categoryName]
      const data = {
        categoryId: [categoryId],
        utm: 'pdss' // 搜索渠道码写死pdss
      }
      creatCollectForm(data)
    }
    //当关键字中包含月嫂时  置顶月嫂
    this.yueSaoTop = this.keyWord.indexOf('月嫂') != -1
  }

  isSelect(name: string) {
    return includes(this.thirdPartScenicScreen, name)
  }

  get cityName() {
    if (this.selectCity?.cityName) {
      return `只看${this.selectCity.cityName}`
    }
    return ''
  }

  get listData() {
    return (type: number) => {
      let list = []
      switch (type) {
        case 1:
          list = this.businessList
          break
        case 2:
          list = this.productList
          break
        case 3:
          list = this.matronList
          break
        case 4:
          list = this.consultantList
          break
        case 5:
          list = this.thirdPartScenicList
          break
        case 6:
          list = this.researchStudyList
          break
        case 7:
          list = this.hotelList
          break
      }
      if (list.length > this.maxShow) {
        list = slice(list, 0, this.maxShow)
      }
      return list
    }
  }

  get moreBusinessExposure() {
    return `${this.clickid_200016}`
  }
  moreBusiness() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200016 })
    this.$emit('setcomponent', '商家')
  }
  get allBusinessExposure() {
    return `${this.clickid_200012}||${JSON.stringify({ keyword: this.$route.query.searchKey || '' })}`
  }
  allBusiness() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200012, positionParam: { keyword: this.$route.query.searchKey || '' } })
    this.$emit('setcomponent', '商家')
  }
  get moreMatronExposure() {
    return `${this.clickid_200018}`
  }
  moreMatron() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200018 })
    this.$emit('setcomponent', '月嫂')
  }
  get allMatronExposure() {
    return `${this.clickid_200014}||${JSON.stringify({ keyword: this.$route.query.searchKey || '' })}`
  }
  allMatron() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200014, positionParam: { keyword: this.$route.query.searchKey || '' } })
    this.$emit('setcomponent', '月嫂')
  }

  allScenic() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: '200021', positionParam: { keyword: this.$route.query.searchKey || '' } })
    this.$emit('setcomponent', TabType.SCENIC)
  }

  moreScenic() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: '200020' })
    this.$emit('setcomponent', TabType.SCENIC)
  }

  moreStudy() {
    // this.$newClickTracker({ ...this.pageTrackParams, clickId: '200020' })
    this.$emit('setcomponent', TabType.STUDY)
  }

  moreHotel() {
    // this.$newClickTracker({ ...this.pageTrackParams, clickId: '200020' })
    this.$emit('setcomponent', TabType.HOTEL)
  }

  clickHotelSort(item: any) {
    this.$emit('setcomponent', TabType.HOTEL)
    this.selectHotelSortInfo(item)
    this.boardcast(SearchRefresh.RefreshHotel)
  }

  changeScenicScreen(type: string, e: any) {
    this.$newClickTracker({
      ...this.pageTrackParams,
      clickId: '200032',
      positionParam: {
        searchtype: e.target.innerText || ''
      }
    })
    this.$emit('setcomponent', TabType.SCENIC)
    this.selectThirdPartScenicScreen(type)
  }

  get moreProductExposure() {
    return `${this.clickid_200017}`
  }
  moreProduct() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200017 })
    this.$emit('setcomponent', '商品')
  }
  get allProductExposure() {
    return `${this.clickid_200013}||${JSON.stringify({ keyword: this.$route.query.searchKey || '' })}`
  }
  allProduct() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200013, positionParam: { keyword: this.$route.query.searchKey || '' } })
    this.$emit('setcomponent', '商品')
  }
  get moreConsultantExposure() {
    return `${this.clickid_200019}`
  }
  moreConsultant() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200019 })
    this.$emit('setcomponent', '育儿顾问')
  }
  get allConsultantExposure() {
    return `${this.clickid_200015}||${JSON.stringify({ keyword: this.$route.query.searchKey || '' })}`
  }
  allConsultant() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200015, positionParam: { keyword: this.$route.query.searchKey || '' } })
    this.$emit('setcomponent', '育儿顾问')
  }

  async refresh() {
    this.setBusinessNum(null)
    this.setProductNum(null)
    this.setYueSaoNum(null)
    this.setResearchStudyNum(null)
    this.setHotelNum(null)
    this.setYuerNum(null)
    this.setThirdPartScenicNum(null)
    this.loading = true
    this.finished = false
    this.errormsg = ''
    const { searchKey = '', tabs = '' } = this.$route.query
    this.keyWord = searchKey as string
    const result = await getSearchResult({ keyWords: this.keyWord, tabs: tabs as string, type: RequestType.RequestAll, start: 0, limit: 9, openOption: true, position: this.location, defaultSort: true })
    const { code = '', msg } = result
    const selectword = [] //埋点用
    if (+code === 1 && result.data) {
      const { data } = result
      this.setCategoryList(data.categoryInfo)
      this.setStudyScreen(data.esTagResp)
      if (data.spotInfo) {
        this.thirdPartScenicList = data.spotInfo.list
        if (data.spotInfo.list.length > 0) {
          selectword.push('景点-门票')
        }
        this.setThirdPartScenicNum(data.spotInfo.total)
      } else {
        this.thirdPartScenicList = []
        this.setThirdPartScenicNum(0)
      }
      if (data.businessInfo) {
        this.businessList = data.businessInfo.list
        //埋点便利是否有景点商品
        for (const item of data.businessInfo.list) {
          if (item && item.spuInfo && item.spuInfo.length > 0) {
            const info = item.spuInfo.find((x: any) => x.templateType2Id === 601 || x.templateType2Id === 602)
            if (info) {
              selectword.push('商家-门票')
              break
            }
          }
        }
        this.setBusinessNum(data.businessInfo.total)
      } else {
        this.businessList = []
        this.setBusinessNum(0)
      }
      if (data.cmmdtyInfo) {
        this.productList = data.cmmdtyInfo.list
        for (const item of data.cmmdtyInfo.list) {
          if (item.templateType2Id === 601 || item.templateType2Id === 602) {
            selectword.push('商品-门票')
            break
          }
        }
        this.setProductNum(data.cmmdtyInfo.total)
      } else {
        this.productList = []
        this.setProductNum(0)
      }
      //月嫂
      if (data.maternityInfo) {
        const { list, total, levelInfo = [], experienceInfo = [] } = data.maternityInfo
        this.matronList = list
        this.setBrightList(experienceInfo)
        this.setLevelList(levelInfo)
        this.setYueSaoNum(total)
      } else {
        this.matronList = []
        this.setYueSaoNum(0)
      }
      //育儿顾问
      if (data.adviserInfo) {
        const { list, total, storeInfo = [] } = data.adviserInfo
        this.consultantList = list
        this.setStoreList(storeInfo)
        this.setYuerNum(total)
      } else {
        this.consultantList = []
        this.setYuerNum(0)
      }
      //研学
      if (data.researchStudy) {
        const { list, total } = data.researchStudy
        this.researchStudyList = list
        this.setResearchStudyNum(total)
      } else {
        this.researchStudyList = []
        this.setResearchStudyNum(0)
      }
      //酒店
      if (data.hotelInfo) {
        const { list, total } = data.hotelInfo
        this.hotelList = list
        this.setHotelNum(total)
      } else {
        this.hotelList = []
        this.setHotelNum(0)
      }
      if (this.isAutoTabChangeForQuery) {
        const { tabIndex } = this.$route.query
        const index = (tabIndex || 0) as number
        if (index == 1 && this.businessNum) {
          this.$emit('setcomponent', TabType.BUSINESS)
        } else if (index == 2 && this.productNum) {
          this.$emit('setcomponent', TabType.PRODUCT)
        } else if (index == 3 && this.thirdPartScenicNum) {
          this.$emit('setcomponent', TabType.SCENIC)
        } else if (index == 4 && this.yueSaoNum) {
          this.$emit('setcomponent', TabType.MATRON)
        } else if (index == 5 && this.yuerNum) {
          this.$emit('setcomponent', TabType.CONSULTANT)
        } else if (index == 6 && this.researchStudyNum) {
          this.$emit('setcomponent', TabType.STUDY)
        } else if (index == 7 && this.hotelNum) {
          this.$emit('setcomponent', TabType.HOTEL)
        }
        this.isAutoTabChangeForQuery = false
      }
    } else {
      this.errormsg = msg || '加载出错，请稍后再试'
      this.$emit('send-to-parent', { code, msg: this.errormsg })
    }
    //添加埋点
    this.$tracker('127', '121012976')({ ...this.pageTrackParams.pageParam, selectword: selectword.join(','), selectterm: this.selectterm })
    this.finished = true
    this.loading = false
    //获取距离顶部的top值 方便点击分类向上自动滑动到顶部
    this.$nextTick(() => {
      const businessClassify = this.$refs.businessClassify as HTMLElement
      const productClassify = this.$refs.productClassify as HTMLElement
      const matronClassify = this.$refs.matronClassify as HTMLElement
      const consultantClassify = this.$refs.consultantClassify as HTMLElement
      const studyClassify = this.$refs.studyClassify as HTMLElement
      const top = this.$el.getBoundingClientRect().top

      if (studyClassify) {
        this.studyClassifySticky = studyClassify.getBoundingClientRect().top - top
      }
      if (businessClassify) {
        this.businessClassifySticky = businessClassify.getBoundingClientRect().top - top
      }
      if (productClassify) {
        this.productClassifySticky = productClassify.getBoundingClientRect().top - top
      }
      if (matronClassify) {
        this.matronClassifySticky = matronClassify.getBoundingClientRect().top - top
      }
      if (consultantClassify) {
        this.consultantClassifySticky = consultantClassify.getBoundingClientRect().top - top
      }
    })
  }

  get locationVis() {
    return this.location && this.location.lat && this.location.lng
  }

  get isSendForm() {
    // 输入关键字是否需要发送需求表单
    const key = ['月嫂', '月子中心', '产康', '产后恢复', '摄影', '百日照']
    return key.filter(item => this.keyWord.includes(item))
  }

  get businessClassifyExposure() {
    return `${this.clickid_200008}`
  }
  changeBusinessCategory(value: any) {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200008, positionParam: { searchtype: '分类' } })
    this.$emit('setcomponent', TabType.BUSINESS)
    this.setBusinessCategorySelect(value)
    this.boardcast(SearchRefresh.RefreshBusiness)
  }

  get productClassifyExposure() {
    return `${this.clickid_200009}`
  }
  changeProductCategory(value: any) {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200009, positionParam: { searchtype: '分类' } })
    this.$emit('setcomponent', TabType.PRODUCT)
    this.setProductCategorySelect(value)
    this.boardcast(SearchRefresh.RefreshProduct)
  }

  changeBusinessDistrict(value: any) {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200008, positionParam: { searchtype: '区域' } })
    this.$emit('setcomponent', TabType.BUSINESS)
    this.setBusinessDistrictSelect(value)
    this.boardcast(SearchRefresh.RefreshBusiness)
  }

  changeProductDistrict(value: any) {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200009, positionParam: { searchtype: '区域' } })
    this.$emit('setcomponent', TabType.PRODUCT)
    this.setProductDistrictSelect(value)
    this.boardcast(SearchRefresh.RefreshProduct)
  }

  changeSortInfo(e: any) {
    this.selectStudySortInfo(e)
    this.$emit('setcomponent', TabType.STUDY)
    this.boardcast(SearchRefresh.RefreshStudy)
  }

  changeAgeTypeInfo(e: any) {
    this.selectAgeTypeInfo(e)
    this.$emit('setcomponent', TabType.STUDY)
    this.boardcast(SearchRefresh.RefreshStudy)
  }
  changeTypeInfo(e: any) {
    this.selectTypeInfo(e)
    this.$emit('setcomponent', TabType.STUDY)
    this.boardcast(SearchRefresh.RefreshStudy)
  }
  changeThemeInfo(e: any) {
    this.selectThemeInfo(e)
    this.$emit('setcomponent', TabType.STUDY)
    this.boardcast(SearchRefresh.RefreshStudy)
  }

  clickDirect(item: any) {
    this.selectDirection(item.ID)
    this.$emit('setcomponent', TabType.STUDY)
    this.boardcast(SearchRefresh.RefreshStudy)
  }

  setSelf() {
    this.selectStudySelf(true)
    this.$emit('setcomponent', TabType.STUDY)
    this.boardcast(SearchRefresh.RefreshStudy)
  }

  get matronClassifyExposure() {
    return `${this.clickid_200010}`
  }
  changeYueSaoLevel(value: any) {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200010, positionParam: { searchtype: '等级' } })
    this.$emit('setcomponent', TabType.MATRON)
    this.setYueSaoLevelSelect(value)
    this.boardcast(SearchRefresh.RefreshMatron)
  }

  changeYueSaoBright(value: any) {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200010, positionParam: { searchtype: '亮点' } })
    this.$emit('setcomponent', TabType.MATRON)
    this.setYueSaoBrightSelect(value)
    this.boardcast(SearchRefresh.RefreshMatron)
  }

  changeYueSaoDistrict(value: any) {
    this.$emit('setcomponent', TabType.MATRON)
    this.setYueSaoDistrictSelect(value)
    this.boardcast(SearchRefresh.RefreshMatron)
  }

  get consultantClassifyExposure() {
    return `${this.clickid_200011}`
  }
  changeYuerStore(value: any) {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200011, positionParam: { searchtype: '门店' } })
    this.$emit('setcomponent', TabType.CONSULTANT)
    this.setYuerStoreSelect(value)
    this.boardcast(SearchRefresh.RefreshConsultant)
  }

  /**
   * 育儿顾问好评排序  育儿顾问距离排序互斥

   */
  changeYuerDistanceSort() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200011, positionParam: { searchtype: '距离' } })
    this.$emit('setcomponent', TabType.CONSULTANT)
    this.setYuerDistanceSort(true)
    this.setYuerGoodCommentsSort(false)
    this.boardcast(SearchRefresh.RefreshConsultant)
  }

  changeYuerGoodCommentsSort() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200011, positionParam: { searchtype: '好评' } })
    this.$emit('setcomponent', TabType.CONSULTANT)
    this.setYuerDistanceSort(false)
    this.setYuerGoodCommentsSort(true)
    this.boardcast(SearchRefresh.RefreshConsultant)
  }

  /**
   * 商家好评排序  商家距离排序互斥
   * 商家距离changeBusinessDistanceSort
   * 商家好评排序  changeGoodCommentSort
   */
  changeBusinessDistanceSort() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200008, positionParam: { searchtype: '距离' } })
    this.$emit('setcomponent', TabType.BUSINESS)
    this.setBusinessDistanceSort(true)
    this.setBusinessGoodCommentSort(false)
    this.boardcast(SearchRefresh.RefreshBusiness)
  }
  changeGoodCommentSort() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200008, positionParam: { searchtype: '好评' } })
    this.$emit('setcomponent', TabType.BUSINESS)
    this.setBusinessGoodCommentSort(true)
    this.setBusinessDistanceSort(false)
    this.boardcast(SearchRefresh.RefreshBusiness)
  }

  /**
   * 商品销量排序  商品距离排序互斥
   * 商品距离排序  changeProductDistanceSort
   * 商品销量排序  changeSalesSort
   */
  changeProductDistanceSort() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200009, positionParam: { searchtype: '距离' } })
    this.$emit('setcomponent', TabType.PRODUCT)
    this.setProductDistanceSort(true)
    this.setProductSalesSort(false)
    this.setProductDefaultSort(false)
    this.boardcast(SearchRefresh.RefreshProduct)
  }
  changeSalesSort() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200009, positionParam: { searchtype: '销量' } })
    this.$emit('setcomponent', TabType.PRODUCT)
    this.setProductSalesSort(true)
    this.setProductDistanceSort(false)
    this.setProductDefaultSort(false)
    this.boardcast(SearchRefresh.RefreshProduct)
  }

  changeDefaultSort(){
    this.$emit('setcomponent', TabType.PRODUCT)
    this.setProductDefaultSort(true)
    this.setProductSalesSort(false)
    this.setProductDistanceSort(false)
    this.boardcast(SearchRefresh.RefreshProduct)
  }

  boardcast(action: string) {
    setTimeout(() => {
      this.$bus.$emit(action)
    }, 100)
  }
}
